import { useState, useEffect } from "react";

const navLinks = [
  { label: "Inicio", href: "#inicio" },
  { label: "Nosotros", href: "#nosotros" },
  { label: "Misión", href: "#mision" },
  { label: "Cursos", href: "#cursos" },
  { label: "Pagos", href: "#pagos" },
  { label: "Testimonios", href: "#testimonios" },
  { label: "Ubicación", href: "#ubicacion" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? "bg-white/95 backdrop-blur-md shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a href="#inicio" onClick={() => handleNav("#inicio")} className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/01cfeae8802c72fb1085873b8b9f4019/447f1458618ef8d5880dd2c7ce622bf2.jpeg"
            alt="Instituto Ashaika Logo"
            className="h-10 md:h-12 w-auto object-contain rounded-md"
          />
          <span
            className={`font-bold text-lg md:text-xl tracking-wide transition-colors duration-300 ${
              scrolled ? "text-[#0A1F44]" : "text-white"
            }`}
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Instituto Ashaika
          </span>
        </a>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.href}>
              <button
                onClick={() => handleNav(link.href)}
                className={`text-sm font-medium tracking-wide transition-all duration-300 hover:text-[#D4AF37] whitespace-nowrap cursor-pointer ${
                  scrolled ? "text-[#0A1F44]" : "text-white/90"
                }`}
              >
                {link.label}
              </button>
            </li>
          ))}
        </ul>

        {/* CTA Button */}
        <a
          href="https://wa.me/523325077743"
          target="_blank"
          rel="noopener noreferrer"
          className="hidden md:flex items-center gap-2 bg-[#D4AF37] text-[#0A1F44] font-semibold text-sm px-5 py-2.5 rounded-full hover:bg-[#c9a42e] transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-whatsapp-line text-base"></i>
          Contáctanos
        </a>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden text-2xl cursor-pointer transition-colors duration-300 ${scrolled ? "text-[#0A1F44]" : "text-white"}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={menuOpen ? "ri-close-line" : "ri-menu-3-line"}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white/98 backdrop-blur-md border-t border-gray-100 px-4 py-4">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNav(link.href)}
              className="block w-full text-left py-3 text-[#0A1F44] font-medium text-base border-b border-gray-100 last:border-0 hover:text-[#D4AF37] transition-colors cursor-pointer"
            >
              {link.label}
            </button>
          ))}
          <a
            href="https://wa.me/523325077743"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 flex items-center justify-center gap-2 bg-[#D4AF37] text-[#0A1F44] font-semibold text-sm px-5 py-3 rounded-full cursor-pointer"
          >
            <i className="ri-whatsapp-line text-base"></i>
            Contáctanos por WhatsApp
          </a>
        </div>
      )}
    </nav>
  );
}
